import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_doc_approval_history_RowClass, bl_aat_claim_document_line_RowClass} from '../../../dbschema';

export class ClaimLineEngagementReportContainerModel extends BaseContainerModel {
  bl_aat_claim_document_line: bl_aat_claim_document_line_RowClass = new bl_aat_claim_document_line_RowClass();
  bl_aat_claim_doc_approval_histories: bl_aat_claim_doc_approval_history_RowClass[] = [];
}

export class EngagementReportBodyRequest {
  claimant_entity_hdr_guid: string; // compulsory
  date_submission_from: string; // optional
  date_submission_to: string; // optional
  date_final_approval_from: string; // default current month start date
  date_final_approval_to: string; // default current month end date
  claim_statuses: string[]; // default Approved
  company_guids: string[]; // List of accessible company's engagement in bl_aat_engagement_company_to_company_access_link.accessed_company_guid
  branch_guids: string[];
  calcTotalRecords?: boolean;
  limit?: number | null;
  offset?: number | null;
}
